import React from "react";
import { Download, Target, Video } from "lucide-react"; // icons

const steps = [
  {
    id: 1,
    title: "Download App",
    description: "Install Revibe on your phone from App Store or Play Store.",
    icon: <Download className="w-10 h-10 text-black" />,
  },
  {
    id: 2,
    title: "Choose Your Goal",
    description:
      "Select your plan, purchase your subscription & start your journey.",
    icon: <Target className="w-10 h-10 text-black" />,
  },
  {
    id: 3,
    title: "Join Classes",
    description: "Train live with experts & access recorded workouts anytime.",
    icon: <Video className="w-10 h-10 text-black" />,
  },
];

const HowItWorks = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-r from-[#C5F122]/10 to-[#758AA9]/10">
      <div className="max-w-6xl mx-auto text-center">
        <h3 className="text-orange-500 font-semibold mb-2">How Revibe Works</h3>
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-black">
          Just 3 Simple Steps
        </h2>

        <div className="grid gap-10 md:grid-cols-3">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center bg-white rounded-2xl shadow-md p-8 hover:shadow-xl transition"
            >
              <div className="bg-gradient-to-r from-[#C5F122] to-[#758AA9] rounded-full w-20 h-20 flex items-center justify-center mb-6">
                {step.icon}
              </div>
              <h4 className="text-xl font-semibold mb-2 text-[#758AA9]">
                {step.title}
              </h4>
              <p className="text-gray-900 leading-relaxed">
                {step.description}
              </p>
              <span className="mt-4 text-sm font-bold text-gray-900">
                Step {step.id}
              </span>
            </div>
          ))}
        </div>

        {/* App Store Buttons */}
        {/* <div className="mt-12 flex justify-center gap-4">
          <a
            href="https://apps.apple.com" // Replace with your real App Store link
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on App Store"
              className="h-12"
            />
          </a>
          <a
            href="https://play.google.com" // Replace with your real Play Store link
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="h-12"
            />
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default HowItWorks;
